import { Flex, Heading } from '@everlywell/ui-kit';
import ReviewsContainer, { SpreeData } from 'containers/PDP/ReviewsContainer';
import Markdown from 'markdown-to-jsx';
import React from 'react';
import { notEmpty } from 'utils/types/utilityTypes';

import ReviewsCard from '../../../ReviewsCard';
import Eyebrow from './components/Eyebrow';
import StatCard from './components/StatCard';

export type PDPReviewsSectionProps = {
  productData: Queries.pdpProductFragment;
} & Queries.pdpSectionFragment;

export default function PDPReviewsSection(props: PDPReviewsSectionProps) {
  const { productData } = props;

  const { spreeProduct, metadata } = productData;

  if (!spreeProduct || !spreeProduct?.powerReviews) return null;

  const { name, productId, powerReviews } = spreeProduct;

  const {
    average_rating: averageRating,
    review_count: reviewCount,
    recommended_ratio: recommendedRatio,
    rating_histogram: ratingHistogram,
  } = powerReviews;

  const reviewsData = {
    powerReviews,
    name,
    productId,
  };

  const hideRating =
    metadata?.flags
      ?.filter(notEmpty)
      .find((flag) => flag.metadata?.metadata_id === 'hideRating')?.value ===
    true;

  return (
    <Flex flexDirection="column" alignItems="center" id="PDPReviewsSection">
      <Flex
        flexDirection={'column'}
        alignItems={'center'}
        gap={2}
        marginBottom={[6, 10]}
      >
        <Eyebrow>{props?.metadata?.title ?? ''}</Eyebrow>
        <Heading size="2xl" marginBottom={3} textAlign="center">
          <Markdown>{props?.metadata?.description?.description ?? ''}</Markdown>
        </Heading>
      </Flex>
      <Flex
        flexDirection={['column', 'row']}
        gap={[3, 4]}
        width={'100%'}
        justifyContent={'center'}
      >
        {!hideRating && <StatCard recommendedRatio={recommendedRatio ?? 0} />}

        <ReviewsCard
          rating={averageRating ?? 0}
          total={reviewCount ?? 0}
          histogram={
            Array.from({ length: 5 }, (_, i) => ratingHistogram?.[i] ?? 0) as [
              number,
              number,
              number,
              number,
              number,
            ]
          }
        />
      </Flex>

      <Flex>
        <ReviewsContainer
          content={{ modalButtonText: 'More reviews' }}
          hideOldDesign
          spreeData={reviewsData as SpreeData}
        />
      </Flex>
    </Flex>
  );
}
